var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "show-domains-template-info-modal",
        title: _vm.$t("label.domain"),
        scrollable: "",
        "hide-footer": "",
      },
    },
    [
      _c("center", [_vm._v(_vm._s(_vm.template.label))]),
      _vm._v(" "),
      _c("b-table", {
        attrs: { fields: _vm.fields, items: _vm.template.domains },
        scopedSlots: _vm._u([
          {
            key: "cell(patgames)",
            fn: function (row) {
              return _vm._l(row.item.patgames, function (id, pos) {
                return _c(
                  "b-badge",
                  { key: "patgames-" + pos, staticStyle: { margin: "1px" } },
                  [_vm._v(_vm._s(_vm.getPatgamesLabel(id)))]
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }